export const APP_TITLE = '安全微课堂'
export const APP_VERSION = '0.1.0'
